module.exports = __webpack_public_path__ + "img/IN.16fcb0a6.svg";